import React, { useState } from 'react';

import { StyledYatHand } from '../../../GroupHeader/GroupHeaderImage/styles';
import { GroupCreateNewPod } from '../GroupCreateNewPod';
import { GroupItemAvatarSkeleton } from '../styles';
import { type NavigatorProps } from '../types';

import { GroupItem } from './components';

import {
    GroupList,
    GroupListWrapper,
    GroupLogoLink,
    GroupsNavigationBackdrop,
    GroupsNavigationContainer,
} from './styles';

const GROUP_PLACEHOLDER_ITEMS_LENGTH = 10;

const GROUPS_NAVIGATION_BACKDROP_VARIANTS = {
    hidden: {
        opacity: 0,
        width: 0,
        transition: {
            duration: 0.3,
            bounce: 0,
        },
    },
    visible: {
        opacity: 1,
        width: 600,
        transition: {
            duration: 0.3,
            bounce: 0,
        },
    },
};

const GROUPS_NAVIGATION_CONTAINER_VARIANTS = {
    hidden: {
        transition: {
            duration: 0.2,
            bounce: 0,
        },
    },
    visible: {
        width: 330,
        transition: {
            duration: 0.2,
            bounce: 0,
        },
    },
};

export const GroupsNavigationDesktop = ({
    isLoading,
    groupsData,
    handleItemClick,
    currentUserId,
    loadMoreItem,
}: NavigatorProps) => {
    const [isHovering, setIsHovering] = useState(false);

    return (
        <>
            <GroupsNavigationContainer
                animate={isHovering ? 'visible' : 'hidden'}
                variants={GROUPS_NAVIGATION_CONTAINER_VARIANTS}
                initial="hidden"
            >
                <GroupListWrapper onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
                    {!isLoading && <GroupCreateNewPod />}
                    <GroupList>
                        {isLoading &&
                            [...Array(GROUP_PLACEHOLDER_ITEMS_LENGTH)].map((_, index) => {
                                return <GroupItemAvatarSkeleton key={`podnav-skeleton-${index}`} />;
                            })}

                        {!isLoading &&
                            groupsData &&
                            groupsData?.map((group) => {
                                return (
                                    <GroupItem
                                        membershipClickable={false}
                                        key={`podnav-${group.id}`}
                                        id={group.id}
                                        name={group.name}
                                        privacy={group.privacy}
                                        members={group?.members?.total || 0}
                                        followers={group?.follower_count || 0}
                                        avatarUrl={group.header_image || null}
                                        isOwner={currentUserId === group.owner}
                                        isMember={group.is_member || false}
                                        owner={group.owner}
                                        onClick={() => handleItemClick(group.slug)}
                                    />
                                );
                            })}
                        {loadMoreItem}
                    </GroupList>
                </GroupListWrapper>
                <GroupLogoLink to="/">
                    <StyledYatHand />
                </GroupLogoLink>
            </GroupsNavigationContainer>
            <GroupsNavigationBackdrop
                animate={isHovering ? 'visible' : 'hidden'}
                variants={GROUPS_NAVIGATION_BACKDROP_VARIANTS}
                initial="hidden"
            />
        </>
    );
};
